import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

const WizardStatus = ({ isSuccess, successMessage, isError, error }) => {
  return (
    <>
      {isError && (
        <>
          <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', p: 3 }}>
            <Avatar sx={{ backgroundColor: 'error.light', height: 56, mb: 3, width: 56 }}>
              <PriorityHighIcon sx={{ color: 'error.dark', fontSize: 32 }} />
            </Avatar>
            <Typography sx={{ color: 'text.primary', mb: 2 }} variant="h6">
              Something went wrong
            </Typography>
            <Typography sx={{ textAlign: 'center' }} variant="body1">
              {error.data.title}
            </Typography>
            <Typography sx={{ textAlign: 'center' }} variant="body1">
              Please submit again
            </Typography>
          </Box>
          <Divider />
        </>
      )}
      {isSuccess && (
        <>
          <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', p: 3 }}>
            <CheckRoundedIcon sx={{ color: 'secondary.main', fontSize: 56, mb: 3 }} />
            <Typography sx={{ color: 'text.primary', mb: 2 }} variant="h6">
              Success!
            </Typography>
            <Typography sx={{ textAlign: 'center' }} variant="body1">
              {successMessage}
            </Typography>
          </Box>
          <Divider />
        </>
      )}
    </>
  );
};

WizardStatus.propTypes = {
  error: PropTypes.shape({
    data: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  isError: PropTypes.bool.isRequired,
  isSuccess: PropTypes.bool.isRequired,
  successMessage: PropTypes.string.isRequired,
};
WizardStatus.defaultProps = {
  error: undefined,
};

export default WizardStatus;
